import { render } from "./Pickers.vue?vue&type=template&id=5bcb2b66"
import script from "./Pickers.vue?vue&type=script&lang=js"
export * from "./Pickers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__